import {
    MaskedInput as motiliUIMaskedTextInput,
    MaskedInputProps,
} from '@motili/ui';
import styled, { css } from 'styled-components';

export interface StyledMaskedTextInputProps extends MaskedInputProps {
    marginTop?: '10px' | '20px' | 'none';
    withLabelSpacing?: boolean;
}

interface TransientProps {
    $marginTop?: '10px' | '20px' | 'none';
    $withLabelSpacing?: boolean;
}

const StyledMaskedTextInput = ({
    marginTop = 'none',
    withLabelSpacing = false,
    ...props
}: StyledMaskedTextInputProps) => {
    return (
        <MaskedTextInput
            $marginTop={marginTop}
            $withLabelSpacing={withLabelSpacing}
            {...props}
        />
    );
};

const MaskedTextInput = styled(motiliUIMaskedTextInput)<TransientProps>`
    display: flex;
    flex-direction: column;

    input {
        border-radius: 0;
        flex: 1;
    }
    label {
        font-family: 'Nunito Sans', sans-serif;
        font-weight: 700;
        text-transform: uppercase;
        flex: 1;
    }
    ${props =>
        props.$marginTop &&
        props.$marginTop !== 'none' &&
        css`
            margin-top: ${props.$marginTop};
        `}

    ${props =>
        props.$withLabelSpacing &&
        css`
            div:first-child {
                margin-bottom: 10px;
            }
        `}
`;

export default StyledMaskedTextInput;
